export const STARTER_PLAN = {
  id: "starter",
  name: "Starter",
  label: "Starter · Monthly",
  badge: "Monthly",
  price: "£29 / month",
  accent: "var(--sys-primary)",
  description: "Perfect for small businesses, freelancers and developers.",
  keyPoints: [
    "3 live links & 500 submissions per month",
    "Structured intake questions and routing",
    "Priority support and custom integrations",
  ],
  ctaLabel: "Upgrade to Starter",
};

export const FREE_PLAN = {
  id: "free",
  name: "Free",
  label: "Free",
  badge: "Current",
  price: "£0",
  accent: "var(--sys-text-muted)",
  description: "Try via a single link.",
  keyPoints: [
    "1 active link",
    "Structured intake questions and routing",
    "Email support",
  ],
  ctaLabel: "Upgrade to Starter",
};

export const LIFETIME_PLANS = [
  {
    id: "lifetime_studio",
    name: "Studio · 10 Site License",
    label: "Studio · 10 Sites",
    badge: "Lifetime Deal",
    price: "£179 one-time",
    accent: "var(--sys-accent-orange)",
    description: "Great for boutique agencies and freelancers.",
    keyPoints: [
      "10 sites included",
      "500 orders per site each month",
      "Lifetime access to all current & future features",
      "Lifetime updates & white-label control",
      "Lifetime priority support",
    ],
    ctaLabel: "Buy Studio Lifetime",
  },
  {
    id: "lifetime_agency",
    name: "Agency · 25 Site License",
    label: "Agency · 25 Sites",
    badge: "Lifetime Deal",
    price: "£349 one-time",
    accent: "var(--sys-primary)",
    description: "Scale-ready toolkit for multi-location rollouts.",
    keyPoints: [
      "25 sites included",
      "1,000 orders per site each month",
      "Lifetime access & all features included",
      "Advanced analytics, integrations & white-label",
      "Lifetime updates & priority support",
    ],
    ctaLabel: "Buy Agency Lifetime",
  },
  {
    id: "lifetime_enterprise",
    name: "Enterprise · 50 Site License",
    label: "Enterprise · 50 Sites",
    badge: "Lifetime Deal",
    price: "£699 one-time",
    accent: "var(--sys-accent-green)",
    description: "For ambitious platforms serving large portfolios.",
    keyPoints: [
      "50 sites included",
      "2,000 orders per site each month",
      "Lifetime access + all current & future features",
      "Full white-label experience",
      "Roadmap input & support for life!",
    ],
    ctaLabel: "Buy Enterprise Lifetime",
  },
];

export const SALE_PLAN_IDS = new Set(LIFETIME_PLANS.map((plan) => plan.id));

export const ALL_UPGRADE_PLANS = [...LIFETIME_PLANS, STARTER_PLAN];

export const getPlanById = (planId) =>
  ALL_UPGRADE_PLANS.find((plan) => plan.id === planId) ||
  (planId === FREE_PLAN.id ? FREE_PLAN : FREE_PLAN);
